import { ComponentProps, FC } from 'react'

import { Link } from 'components/links'
import LinkedinIcon from 'icons/social/linkedin.svg'
import { cn } from 'utils'

import classes from './linkedin-link.module.css'

interface LinkedinLinkProps extends ComponentProps<typeof Link> {
  name: string
}

export const LinkedinLink: FC<LinkedinLinkProps> = ({ className, name, ...props }) => {
  return (
    <Link
      target="_blank"
      prefetch={false}
      {...props}
      aria-label={`Link to ${name} profile`}
      className={cn(classes.icon, className)}
    >
      <LinkedinIcon />
    </Link>
  )
}
